import axios from 'axios';
import { JsonResponse } from 'core/models/response';

import {
	LoyalityProgamListResponse,
	LoyalityProgramStatus,
	LoyaltyProgram,
	LoyaltyProgramTreasuryInfo,
	SimulateDistributionResponse,
	SimulateDistributionPayload,
	LoyalityVerificationPayload,
	CreateLoyalityProgramPayload,
} from '../models/loyaltyProgram';

export const onGetLoyaltyProgramStatus = async () => {
	try {
		const response = await axios.get<JsonResponse<LoyalityProgramStatus>>('dashboard/actions/loyalty-program/status');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendActivationOtp = async () => {
	try {
		const response = await axios.post<JsonResponse<{ ttl: 120 }>>('dashboard/actions/loyalty-program/send-activation-otp');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onActivateLoyaltyProgram = async (payload: LoyalityVerificationPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program/activate`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetTreasuryShares = async () => {
	try {
		const response = await axios.get<JsonResponse<LoyaltyProgramTreasuryInfo>>(`dashboard/actions/loyalty-program/treasury-info`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetLoyaltyProgramsList = async (page: number) => {
	try {
		const response = await axios.get<JsonResponse<LoyalityProgamListResponse>>(`dashboard/actions/loyalty-program?page=${page}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetLoyaltyProgramById = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<LoyaltyProgram>>(`dashboard/actions/loyalty-program/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelLoyaltyProgram = async (id: number) => {
	try {
		const response = await axios.post<JsonResponse<LoyaltyProgram>>(`dashboard/actions/loyalty-program/${id}/cancel`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSimulateDistributionLoyaltyProgramDates = async (payload: SimulateDistributionPayload) => {
	try {
		const response = await axios.post<JsonResponse<SimulateDistributionResponse>>(`dashboard/actions/loyalty-program/simulate`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateLoyaltyProgram = async (payload: CreateLoyalityProgramPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDistributeLoyaltyProgram = async (id: number, payload?: LoyalityVerificationPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program/distributions/${id}/distribute`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendOtpDistributeLoyaltyProgram = async (id: number) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program/distributions/${id}/send-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCancelDistributionLoyaltyProgram = async (id: number, payload?: LoyalityVerificationPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program/distributions/${id}/cancel`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendOtpCancelDistributionLoyaltyProgram = async (id: number) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/loyalty-program/distributions/${id}/send-cancel-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendLoyaltyOtp = async () => {
	try {
		const response = await axios.post(`dashboard/actions/loyalty-program/send-store-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};